module.exports = __webpack_public_path__ + "img/humpback.e624e9fd.png";